var render, staticRenderFns
import script from "./simple-list.vue?vue&type=script&lang=js"
export * from "./simple-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('792f3e91')) {
      api.createRecord('792f3e91', component.options)
    } else {
      api.reload('792f3e91', component.options)
    }
    
  }
}
component.options.__file = "resources/assets/js/components/secutity-group/simple-list.vue"
export default component.exports